import { $t } from '@/i18n';
import { defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api';
import { AIStyleManager } from '@/modules/ai-page/ai-project/ai-styles';
import { provideAIEditorContext, mountAIEditorContext } from '@/modules/ai-page/hooks/useContext';
import { jsonToYaml } from '@/utils/merge/jsonToYaml';
import { syncMonacoTheme } from '@/modules/ai-page/setupShiki';
// 动态导入 GogoEditor 避免循环依赖
const GogoEditor = () => import('@/modules/ai-page/GogoEditor.vue');
export default defineComponent({
    name: 'AIConflictView',
    components: {
        GogoEditor,
    },
    props: {
        conflictItem: {
            type: Object,
            default: () => ({}),
        },
        currentBranchLabel: {
            type: String,
            default: '',
        },
        mergeBranchLabel: {
            type: String,
            default: '',
        },
    },
    emits: ['change', 'mergeSuccess'],
    setup() {
        const styleManager = AIStyleManager.getInstance();
        // 提供 AI Editor Context（先 provide 再 mount）
        provideAIEditorContext();
        mountAIEditorContext(() => ({
            async manualUpdatePackageJSON(_pkgJSON, _options) {
                // 合并场景下不需要手动更新依赖
                console.log('[AIConflictView] manualUpdatePackageJSON called in merge mode, ignoring');
            },
            getPackageJSON() {
                return '{}';
            },
            ready: ref(true),
        }));
        onMounted(() => {
            // 创建AI编辑器专用样式
            styleManager.createAIStyles();
            syncMonacoTheme();
        });
        onUnmounted(() => {
            // 组件卸载时删除样式
            styleManager.removeAIStyles();
        });
        return {};
    },
    data() {
        return {
            mergeSuccess: false,
        };
    },
    computed: {
        oursMainBranch() {
            return this.conflictItem?.oursData?.mainBranch || '';
        },
        theirsMainBranch() {
            return this.conflictItem?.theirsData?.mainBranch || '';
        },
    },
    methods: {
        handleAIMergeSuccess(data) {
            // 将AI项目合并成功事件向上传递
            const change = jsonToYaml(data.projectInfo);
            this.$emit('change', change);
            // 设置合并成功状态
            this.mergeSuccess = true;
        },
    },
    render() {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const Editor = GogoEditor;
        // 如果合并成功，显示成功提示
        if (this.mergeSuccess) {
            return (<div style={{
                    width: '100%',
                    height: 'calc(100vh - 230px)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '16px',
                }}>
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" style={{ marginBottom: '8px' }}>
            <circle cx="32" cy="32" r="32" fill="#52c41a"/>
            <path d="M20 32l8 8 16-16" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div style={{
                    fontSize: '18px',
                    fontWeight: 500,
                    color: '#333',
                }}>
            {$t('k_d02e5af9')}
          </div>
          <div style={{
                    fontSize: '14px',
                    color: '#666',
                }}>
            {$t('k_3ba7f23c')}
          </div>
        </div>);
        }
        return (<div style={{ width: '100%', maxHeight: 'calc(100vh - 230px)' }}>
        <Editor merge={{
                ours: this.oursMainBranch,
                theirs: this.theirsMainBranch,
                oursName: this.currentBranchLabel,
                theirsName: this.mergeBranchLabel,
            }} onMergeSuccess={this.handleAIMergeSuccess}/>
      </div>);
    },
});
